"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames_1 = require("classnames");
var _1 = require("./");
var icon_1 = require("../icon");
var utils_1 = require("../utils");
var MenuNode = /** @class */ (function (_super) {
    tslib_1.__extends(MenuNode, _super);
    function MenuNode(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.open = function () {
            var isOpen = _this.state.isOpen;
            if (!isOpen) {
                _this.setState({ isOpen: true });
            }
        };
        _this.close = function () {
            var isOpen = _this.state.isOpen;
            if (isOpen) {
                _this.setState({ isOpen: false });
            }
        };
        _this.onClick = function (e) {
            var _a = _this.props, onClick = _a.onClick, item = _a.item;
            if (item.disabled) {
                utils_1.pauseEvent(e);
                return;
            }
            var onMenuItemClick = _this.context.onMenuItemClick;
            onMenuItemClick && onMenuItemClick(item);
            onClick && onClick(e);
            _this.close();
        };
        _this.state = { isOpen: false };
        return _this;
    }
    MenuNode.prototype.render = function () {
        var _a;
        var _b = this.props, theme = _b.theme, item = _b.item, level = _b.level;
        var isOpen = this.state.isOpen;
        var hasMoreItems = item.items && item.items.length > 0;
        var classes = classnames_1.default((_a = {},
            _a[theme.link] = item.link && this.context.linkComponent,
            _a[theme.hasMore] = hasMoreItems,
            _a[theme.aggregator] = item.rootAggregator,
            _a));
        var content = (React.createElement(React.Fragment, null,
            item.iconName ? React.createElement(icon_1.Icon, { className: theme.icon, iconName: item.iconName, size: 2 }) : null,
            item.title,
            hasMoreItems && level > 0 ? React.createElement(icon_1.Icon, { className: theme.hasMoreIcon, iconName: "icon-arrow-right-small", size: 1.4 }) : ""));
        if (item.link && this.context.linkComponent && !item.disabled) {
            var LinkComponent = this.context.linkComponent;
            content = React.createElement(LinkComponent, tslib_1.__assign({}, item.link), content);
        }
        var props = {
            className: classes,
            onMouseEnter: this.open,
            onMouseLeave: this.close,
            onClick: this.onClick
        };
        if (item.warmup && !item.disabled) {
            props.onMouseDown = item.warmup;
        }
        return (React.createElement("li", tslib_1.__assign({}, props, { "data-disabled": item.disabled }),
            React.createElement("div", { className: theme.title }, content),
            hasMoreItems && !item.disabled ? React.createElement(_1.MenuSubTree, { items: item.items, isOpen: isOpen, level: level + 1 }) : null));
    };
    MenuNode.defaultProps = {};
    MenuNode.contextTypes = {
        onMenuItemClick: PropTypes.func,
        linkComponent: PropTypes.any
    };
    return MenuNode;
}(React.Component));
exports.default = MenuNode;
